import { Button } from '@goodboydigital/astro';
import { Container, Sprite, Texture } from 'pixi.js';

import { Shared } from '../App';

export enum IconSizes
    {
    'small' = 60,
    'medium' = 80,
    'large' = 120,
    'xLarge' = 150,
}

export const defaultOpts = {
    accessible: false,
    icon: new Container(),
    accessibleTitle: 'Name',
    tabIndex: 2,
    buttonEnabled: true,
    onClick: (): any => { /* */ },
    unlocked: false,
    coinCost: 0,
    diamondCost: 0,
    size: IconSizes.medium,
    active: false,
    anchor: { x: 0.5, y: 0.5 },
    activeTexture: 'blank',
    inactiveTexture: 'blank',
};

export type ShopIconSizes = 'small' | 'medium' | 'large';

export type ShopIconOpts = typeof defaultOpts;

export class ShopIcon extends Button
{
    public view: Sprite;
    public iconHolder: Container;
    public icon: Container;

    public width: number;
    public height: number;

    protected active: boolean;
    protected activeTexture: Texture;
    protected inactiveTexture: Texture;

    constructor(opts: Partial<ShopIconOpts> = {})
    {
        const o = { ...defaultOpts, ...opts };

        const view = new Sprite();

        super(view, o);
        this.view = view;
        this.view.anchor.set(o.anchor.x, o.anchor.y);

        this.activeTexture = Shared.assets.getTexture(o.activeTexture);
        this.inactiveTexture = Shared.assets.getTexture(o.inactiveTexture);

        this.enabled = o.buttonEnabled;
        this.accessible = o.accessible;
        this.onPress.connect(() => o.onClick());

        this.width = o.size;
        this.height = o.size;

        this.active = o.active;
        this.view.texture = this.active ? this.activeTexture : this.inactiveTexture;

        this.view.width = o.size;
        this.view.height = o.size;

        this.iconHolder = new Container();
        this.view.addChild(this.iconHolder);

        this.icon = o.icon;

        this.iconHolder.addChild(this.icon);
    }

    public setSize(val: ShopIconSizes): void
    {
        this.view.height = IconSizes[val];
        this.view.width = IconSizes[val];
    }

    public updateIcon(newIcon: Container): void
    {
        this.iconHolder.removeChildren();
        this.iconHolder.addChild(newIcon);

        this.icon = newIcon;
    }

    public get state(): boolean { return this.active; }
    public set state(state: boolean)
    {
        this.active = state;
        this.view.texture = this.active ? this.activeTexture : this.inactiveTexture;
    }
}
